import type {ReactElement} from 'react';
import React, {useRef, useState} from 'react';
import type {VideoThumbnailProps} from './video-thumbnail.types';
import {noop} from '@Utils/general.util';
import {SkeletonBrick} from '@Components/skeleton-brick';
import {ClickableDiv} from '@Components/clickable-div';

export function VideoThumbnail({onClick = noop, ...props}: VideoThumbnailProps): ReactElement {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleMouseEnter = (): void => {
    setShowVideo(true);
    void videoRef.current?.play();
  };

  const handleMouseLeave = (): void => {
    setShowVideo(false);
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  };

  const getSkeletonBrickForLoadingState = (): ReactElement | null => {
    if (!props.data.showSkeletonLoading) {
      return null;
    }
    return <SkeletonBrick theme={props.data.skeletonLoadingTheme} className={`_position-absolute ${props.className ?? ''}`} />;
  };

  return (
    <ClickableDiv className={`_position-relative flex-center _full-width _full-height`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={onClick}>
      {isImageLoaded ? null : getSkeletonBrickForLoadingState()}
      <img
        className={`_position-absolute ${props.className}`}
        src={props.data.imageSrc}
        onLoad={(): void => {
          setIsImageLoaded(true);
        }}
        alt={window.i18next.t('pmwjs_image')}
      />
      <video ref={videoRef} className={`_position-absolute ${props.className} ${showVideo ? '' : '_hidden'}`} src={props.data.videoSrc} />
    </ClickableDiv>
  );
}
